import React, { ReactElement } from 'react';

import './user-faq.base.scss';
import Link from 'atomic/link/link';

const UserFaqBase: React.FC = (): ReactElement => (
    <div className="user-faq">
        <h2 className="user-faq__question">
            Czy muszę założyć konto w serwisie Opineo.pl, aby wystawić opinię?
        </h2>
        <div className="user-faq__answer">
            Do wyrażenia opinii w serwisie Opineo.pl nie jest wymagane założenie przez Ciebie konta. Opinię możesz
            dodać również jako niezarejestrowany użytkownik.
        </div>
        <h2 className="user-faq__question">
            Czy mogę samodzielnie edytować lub usunąć dodaną przeze mnie opinię?
        </h2>
        <div className="user-faq__answer">
            Serwis Opineo.pl nie udostępnia możliwości edycji treści opinii. Jeżeli chcesz usunąć swoją opinię
            - prześlij nam zgłoszenie z adresu e-mail użytego do rejestracji opinii - na adres
            {' '}
            <Link href="mailto:admin@opineo.pl">
                admin@opineo.pl
            </Link>
            .
            Zawnioskuj o to usunięcie jeżeli Twoja opinia ma być usunięcia w związku z wyrażeniem nowej opinii
            ze zmienioną treścią i/lub oceną.
        </div>
        <h2 className="user-faq__question">
            W jaki sposób mogę zgłosić chęć usunięcia moich danych z serwisu Opineo.pl?
        </h2>
        <div className="user-faq__answer">
            Najprościej dyspozycję usunięcia danych złożysz na adres:
            {' '}
            <Link href="mailto:admin@opineo.pl">
                admin@opineo.pl
            </Link>
            {' '}
            lub listownie na adres
            poczty tradycyjnej wskazany w zakładce Kontakt i w regulaminie.
        </div>
    </div>
);

export default UserFaqBase;
